import * as React from 'react'
export const SvgBagSelected = (props: React.SVGProps<SVGSVGElement>) => (
  <svg data-name="Layer 1" viewBox="0 0 24 24" {...props}>
    <path d="M18.24 7.74h-2.41V6.11a4.19 4.19 0 00-4.1-4.21 4.15 4.15 0 00-4.2 4.15v1.69H5.11a1 1 0 00-1 1v12.14a1 1 0 001 1h13.13a1 1 0 001-1V8.76a1 1 0 00-1-1.02zm-9.65 6.6H7.48V9.2h1.11zm6.18-6.6H8.59V6.05a3.09 3.09 0 016.18 0zm1.12 6.46h-1.12V9.06h1.12z" />
  </svg>
)
export default SvgBagSelected
